import type { IEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';

export class NotificationReadEvent implements IEvent {}

export class NotificationMessageEvent implements IEvent {}
